// src/utils/browserUtils.js
// 检测是否为UC浏览器
export const isUCBrowser = () => {
  return /UCBrowser/i.test(navigator.userAgent);
};

// 检测是否为Safari浏览器
export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

// 确保视频在Safari中正常播放
export const ensureSafariVideoPlayback = (videoElement) => {
  if (isSafari() && videoElement) {
    videoElement.setAttribute('playsinline', 'true');
    videoElement.setAttribute('webkit-playsinline', 'true');
    // 移除静音设置，因为它可能导致倍速播放
    // videoElement.removeAttribute('muted');
  }
};

// 检测是否为iOS设备
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

// 检测是否为Android设备
export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};

// 检测是否为鸿蒙设备
export const isHarmonyOS = () => {
  return /OpenHarmony/i.test(navigator.userAgent);
};

// 检测是否为Chrome浏览器
export const isChrome = () => {
  return /Chrome/i.test(navigator.userAgent) && !/Edge/i.test(navigator.userAgent);
};

// 检测是否为微信浏览器
export const isWeChat = () => {
  return /MicroMessenger/i.test(navigator.userAgent);
};

export default {
  isUCBrowser,
  isSafari,
  ensureSafariVideoPlayback,
  isIOS,
  isAndroid,
  isChrome
};